module.exports = __webpack_public_path__ + "static/media/male04.1034c008.jpg";